import { request } from './http';
import {
  GoogleSearchConsoleSite,
  Integration,
  IntegrationDetail,
} from './types';

const base = (projectId: string) =>
  `/integrations/project/${encodeURIComponent(projectId)}`;

export const listIntegrations = (projectId: string) =>
  request<{ integrations: Integration[] }>(base(projectId), 'GET');

export const getIntegration = (projectId: string, integrationId: string) =>
  request<IntegrationDetail>(
    `${base(projectId)}/${encodeURIComponent(integrationId)}`,
    'GET',
  );

/**
 * The key is sent once and never returned. A 400 carries a message suitable
 * for showing to the user (wrong key type, missing permissions); a 409 means
 * this account and mode are already connected to the project.
 */
export const connectStripe = (projectId: string, body: { apiKey: string }) =>
  request<Integration, typeof body>(`${base(projectId)}/stripe`, 'POST', body);

export const connectRevenueCat = (
  projectId: string,
  body: {
    apiKey: string;
    revenueCatProjectId: string;
    environment: 'production' | 'sandbox';
  },
) =>
  request<Integration, typeof body>(
    `${base(projectId)}/revenuecat`,
    'POST',
    body,
  );

export const authorizeGoogleSearchConsole = (
  projectId: string,
  returnTo?: 'setup',
) =>
  request<{ authorizationUrl: string }, { returnTo?: 'setup' }>(
    `${base(projectId)}/google-search-console/authorize`,
    'POST',
    { returnTo },
  );

export const listGoogleSearchConsoleProperties = (
  projectId: string,
  ticket: string,
) =>
  request<{ sites: GoogleSearchConsoleSite[] }, { ticket: string }>(
    `${base(projectId)}/google-search-console/properties`,
    'POST',
    { ticket },
  );

export const connectGoogleSearchConsole = (
  projectId: string,
  body: { ticket: string; siteUrl: string },
) =>
  request<Integration, typeof body>(
    `${base(projectId)}/google-search-console`,
    'POST',
    body,
  );

export const disconnectIntegration = (
  projectId: string,
  integrationId: string,
) =>
  request<{ message: string }>(
    `${base(projectId)}/${encodeURIComponent(integrationId)}`,
    'DELETE',
  );

export const resyncIntegration = (projectId: string, integrationId: string) =>
  request<{ message: string }>(
    `${base(projectId)}/${encodeURIComponent(integrationId)}/resync`,
    'POST',
  );
